<template>
  <el-container>
    <el-aside width="15%">
      <div class="menu" style="height: 830px">
        <el-menu
          default-active="2"
          class="el-menu-vertical-demo"
          background-color="#afc5e2"
          text-color="#fff"
          @select="changeSidebar"
          active-text-color="#ffd04b">
          <el-menu-item index="/index/Eles">
            <i class="el-icon-s-custom"></i>
            <span slot="title">元素库</span>
          </el-menu-item>
          <el-menu-item index="/index/Cases">
            <i class="el-icon-s-claim"></i>
            <span slot="title">用例库</span>
          </el-menu-item>
          <el-menu-item index="/index/Result">
            <i class="el-icon-s-shop"></i>
            <span slot="title">运行结果</span>
          </el-menu-item>
        </el-menu>
      </div>
    </el-aside>
    <el-container>
      <el-main>
        <!-- 仔细看，核心在这，这里是路由的出口-->

        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  mounted () {
    this.sidebarItem = this.$route.name
  },
  methods: {
    changeSidebar (path) {
      this.$router.push(path)
    }
  }
}
</script>

<style scoped>
.menu{
  height: 730px;
  background-color:  #afc5e2;
}
.el-header {
  background-color: #afc5e2;
  color: #333;
  font-size:30px;
  text-align: center;
  line-height: 60px;
}
.el-aside {
  color: #333;
  text-align: center;
  line-height: 900px;
}
.el-main {
  background-color: #cfebe43f;
  color: #2196f3;
  /* text-align: center; */
  line-height: 160px;
  padding: 0px ! important;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue